<template lang="html">
  <div class="vid-int-noWebcam">
    <div class="vid-int-noWebcam__inner vid-int-noWebcam__message">
        <div class="h2">
            {{ $tr('videoInterview.noWebcam.title') }}
        </div>
        <div class="vid-int-noWebcam__item vid-int-noWebcam__content">
            {{ $tr('videoInterview.noWebcam.content') }}
        </div>
    </div>
    <div class="vid-int-noWebcam__inner vid-int-noWebcam__img-container">
        <img class="vid-int-noWebcam__img" src="/static/images/elements/no-webcam.jpg" alt="no-webcam-img"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'interview-equipment-check-no-webcam'
}
</script>

<style lang="scss" scoped>
    .vid-int-noWebcam {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        line-height: 24px;
        box-sizing: border-box;
        width: 100%;
        margin-left: auto;
        margin-right: auto;

        @media screen and (max-width: 1024px) {
            flex-direction: column-reverse;
        }
    }

    .vid-int-noWebcam__message {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        max-width: 400px;
        width: 100%;

        @media screen and (max-width: 1024px) {
            margin-top: 1rem;
        }
    }

    .vid-int-noWebcam__img-container {
        max-width: 400px;
        width: 100%;
    }

    .vid-int-noWebcam__img {
        max-width: 100%;
        height: auto;
    }

    .vid-int-noWebcam__inner {
        margin-right: 50px;

        @media screen and (max-width: 1024px) {
            margin-right: 0;
        }
    }

    .vid-int-noWebcam__inner:last-child {
        margin-right: 0;
    }

    .vid-int-noWebcam__item {
        margin-bottom: 30px;
    }

    .vid-int-noWebcam__item:last-child {
        margin-bottom: 0;
    }

    .vid-int-noWebcam__title {
        color: #49bc00;
    }
</style>
